import React from 'react';

const HeroSection: React.FC = () => {
  const heroSectionStyle: React.CSSProperties = {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg,rgb(254, 104, 184) 10%,rgb(244, 13, 209) 25%,rgb(243, 45, 75) 40%,rgb(117, 14, 213) 75%, #00ced1 100%)',
    overflow: 'hidden',
  };

  const heroContentStyle: React.CSSProperties = {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    maxWidth: '1000px',
    padding: '0 2rem',
    animation: 'fadeInUp 1.2s ease-out',
  };

  const heroLogoStyle: React.CSSProperties = { 
    animation: 'fadeInDown 1s ease-out 0.2s both',
  };

  const heroLogoImgStyle: React.CSSProperties = {
    height: '100px',
    width: 'auto',
    filter: 'drop-shadow(0 0 20px rgba(255, 105, 180, 0.3))',
  };

  const heroTitleStyle: React.CSSProperties = {
    fontSize: '3rem',
    fontWeight: 700,
    color: '#ffffff',
    marginBottom: '4rem', 
    animation: 'fadeInUp 1s ease-out 0.4s both',
  };

  const heroDescriptionStyle: React.CSSProperties = {
    color: '#cbd5e1',
    fontSize: '1.25rem',
    lineHeight: 1.8,
    fontWeight: 300,
    animation: 'fadeInUp 1s ease-out 0.6s both',
    marginBottom:'3rem'
  };

  const descriptionPStyle: React.CSSProperties = {
    marginBottom: '1rem',
  };









  return (
    <>
      {/* 添加CSS动画到head */}
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(50px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-50px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }





          /* 响应式样式 */
          @media (max-width: 768px) {
            .hero-content {
              padding: 0 1.5rem !important;
            }
            
            .hero-logo {
              margin-bottom: 2rem !important;
            }
            
            .hero-logo-img {
              height: 80px !important;
            }
            
            .hero-title {
              font-size: 2.5rem !important;
              margin-bottom: 1.5rem !important;
            }
            
            .hero-description {
              font-size: 1.125rem !important;
            }
          }

          @media (max-width: 480px) {
            .hero-title {
              font-size: 2rem !important;
            }
            
            .hero-description {
              font-size: 1rem !important;
            }
            
            .hero-logo-img {
              height: 60px !important;
            }
          }

          /* 增强动画效果 */
          .hero-content {
            animation: fadeInUp 1.5s ease-out !important;
          }

          .hero-logo {
            animation: fadeInDown 1.2s ease-out 0.3s both !important;
          }

          .hero-title {
            animation: fadeInUp 1.2s ease-out 0.6s both !important;
          }

          .hero-description {
            animation: fadeInUp 1.2s ease-out 0.9s both !important;
          }


        `}
      </style>

      <section style={heroSectionStyle}>
        <div style={heroContentStyle} className="hero-content">
          <div style={heroLogoStyle} className="hero-logo">
            <img 
              src="/software-logo.png" 
              alt="悟空软件开发"
              style={heroLogoImgStyle}
              className="hero-logo-img"
            />
          </div>
          
          <h1 style={heroTitleStyle} className="hero-title">
            感受AI带来的软件生产力革命，从圆领开始
          </h1>
          
          <div style={heroDescriptionStyle} className="hero-description">
            <p style={descriptionPStyle}>技术开发和运维交给我们，您只需专注自身业务。</p> 
          </div>
        </div>
        

      </section>
    </>
  );
};

export default HeroSection; 